export interface FailedVendorColumn {
  name: string;
  styleHead: string;
  render?: (item: any) => string;
  slotName?: string;
  "custom-slot"?: boolean;
  styleCustom?: string;
}

export const DEFAULT_FAILED_VENDOR_STT_REASON = "Tidak ada respon dari vendor";

export function resolveFailedVendorSttReason(
  reason?: string,
  message?: string,
  fallbackReason = DEFAULT_FAILED_VENDOR_STT_REASON
): string {
  const cleanReason = (reason || "").trim();
  const cleanMessage = (message || "").trim();
  return cleanReason || cleanMessage || fallbackReason;
}

export function getFailedVendorColumns(
  t: (key: string) => string
): FailedVendorColumn[] {
  return [
    {
      name: t("handover.list.failedVendorModal.sttNo"),
      styleHead: "w-50 text-left whitespace-no-wrap",
      render: (item: any) =>
        `<div class="overflow-ellipsis text-left text-black-lp-300">${item.sttNo}</div>`
    },
    {
      name: t("handover.list.failedVendorModal.product"),
      styleHead: "w-32 text-left whitespace-no-wrap",
      render: (item: any) =>
        `<div class="overflow-ellipsis text-left text-black-lp-300">${item.product}</div>`
    },
    {
      name: t("handover.list.failedVendorModal.commodity"),
      styleHead: "w-40 text-left whitespace-no-wrap",
      render: (item: any) =>
        `<div class="overflow-ellipsis text-left text-black-lp-300">${item.commodity}</div>`
    },
    {
      name: t("handover.list.failedVendorModal.pieces"),
      styleHead: "w-24 text-left whitespace-no-wrap",
      render: (item: any) =>
        `<div class="overflow-ellipsis text-left text-black-lp-300">${item.pieces}</div>`
    },
    {
      name: t("handover.list.failedVendorModal.grossWeight"),
      styleHead: "w-32 text-left whitespace-no-wrap",
      render: (item: any) =>
        `<div class="overflow-ellipsis text-left text-black-lp-300">${item.grossWeight}</div>`
    },
    {
      name: t("handover.list.failedVendorModal.volumeWeight"),
      styleHead: "w-32 text-left whitespace-no-wrap",
      render: (item: any) =>
        `<div class="overflow-ellipsis text-left text-black-lp-300">${item.volumeWeight}</div>`
    },
    {
      name: t("handover.list.failedVendorModal.reason"),
      slotName: "reason",
      "custom-slot": true,
      styleHead: "w-80 text-left whitespace-no-wrap",
      styleCustom: "w-80"
    }
  ];
}
